<template>
  <div class="container-fluid">
    <div class="item" :key="product.id + index" v-for="(product, index) in products">
      <router-link :to="{path : '/product/'+ product.id }">
        <div class="product__image-container">
          <div class="product__image" :style="'background-image: url(' + product.images[0] + ')'">
          </div>
        </div>
      </router-link>
    <div class="product__description">
      <h2><router-link v-if="product.name.length !== 0" :to="{path : '/product/'+ product.id }">{{ product.name }}</router-link></h2>
      <router-link class="full-name" v-if="product.fullName.length !== 0" :to="{path : '/product/'+ product.id }">{{ product.fullName }}</router-link>
      <p class="product_price">{{ product.price }} <span>₽ с НДС</span></p>
      <router-link class="ye-button" :to="{path : '/product/'+ product.id }">Перейти</router-link>
    </div>
    </div>
  </div>
</template>

<script>

// import axios from "axios"

export default {
  name: 'Products',
  props: ['products'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full-name {
  font-weight: 300;
  font-size: 15px;
}

.product_price {
  font-weight: 500;
}

.product_price span{
  font-weight: 300;
}

h2 {
  font-size: 15px;
  margin: 0 0 6px 0;
  font-weight: 500;
}

.product__image {
  width: 95%;
  height: 200px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

}

.product__image-container {
  background: #f2f2f2;
}

.product__description {
  padding-top: 12px;
  padding-bottom: 20px;
}

.container-fluid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
}

.container-fluid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
}

.item {
  max-width: calc((100% / 3) - 1rem);
  flex: 1 1 calc((100% / 3) - 1rem);
  height: 100%;
  text-align: left;
}

.container-fluid::after {
  /*max-width: calc((100% / 3) - 1rem);*/
  /*flex: 1 1 calc((100% / 3) - 1rem);*/
  flex-basis: calc((100% / 3) - 1rem);
  content: "";
}

.item img {
  width: 100%;
}

.category-item__name {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  margin-top: 0;
  flex-grow: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f202a;
  position: relative;
  padding-bottom: 10px;
  text-align: left;
}

.category-item__name:after {
  content: '';
  position: absolute;
  bottom: 0;
  height: 5px;
  background: #dd291a;
  width: 100%;
  left: 0;
}

@media (max-width: 750px) {
  .item {
    max-width: calc((100% / 2) - 0.5rem);
    flex: 1 1 calc((100% / 2) - 0.5rem);
  }
}

@media (max-width: 400px) {
  .item {
    max-width: 100%;
    flex: 1 1 100%;
  }
}


</style>
